import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import RootLayout from './root-layout'
import ExecutivePage from '@/executive/page'
import HomePage from '@/home/page'
import ProfilePlaybookPage from '@/profiles/page'
import MatchingPage from '@/matching/page'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <ExecutivePage /> },
      { path: 'research', element: <HomePage /> },
      { path: 'profiles', element: <ProfilePlaybookPage /> },
      { path: 'matching', element: <MatchingPage /> },
    ],
  },
])

export function AppRouter() {
  return <RouterProvider router={router} />
}
